module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAeFBMVEUAAAAt1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t0t1t1QfGMWAAAAJ3RSTlMAwNBQ8d7q5fjGr5GMfiwmEfW9tatlA4V6al5WS0caDAuim4E7NjVJFmQ0AAAArklEQVQoz52O2Q6DIBBFoZRFBbe6V61d5///sGFMgwVf2vPATObkkkt+pxKq3RXPUUO6n8mBH3zoaI2Q1IfHVpQn4qMr+yY8EBQTNVy8eyOMHQ94eSIV01pr8MQgZpxSeyIROMJaER7CWk1xxxnUSoF9Fs22VConK508buFnl156k60ba6evHkoUaAxwqN09A7YcO7vxG4kjJ3IVG8CfS97LK3EwWSQNZiOgM/mHN1osCRx2Au2oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tc-hover.png
// module id = 452
// module chunks = 0 1 2 3 4 5 6 7